import { useSearchParams } from 'next/navigation'
import { stringifyUrl } from 'query-string'
import * as React from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { MaybeSpaLink } from '../../../../../../lib/adapters/next-routing-service/MaybeSpaLink'
import { trackEvent } from '../../../../../../lib/analytics'
import { CollectionLink } from '../../../../../../types/graphql'

import { Body, LinkItem, Links, ListWrapper, Title } from './styles'

export const CollectionLinks: React.FC<{ links: CollectionLink[] }> = ({ links }) => {
  const {
    detailsSection: { collectionLinksTitle },
  } = useTranslation()
  // plain=true query param is used by iOS app to view webpages within a webview without the website's header/footer
  const plainQueryParamValue = useSearchParams()?.get('plain') ?? undefined

  if (!links.length) return null

  const getItemUrl = (url: string) => {
    const query = { plain: plainQueryParamValue }
    return stringifyUrl({ url, query })
  }

  return (
    <Body>
      <Title textTransform='uppercase'>{collectionLinksTitle}</Title>
      <Links>
        {links.map((link: CollectionLink) => (
          <ListWrapper key={link.text}>
            <MaybeSpaLink href={getItemUrl(link.href)}>
              <LinkItem
                {...trackEvent({
                  category: 'product-details',
                  action: 'category-link',
                  label: link.text,
                })}
              >
                {link.text}
              </LinkItem>
            </MaybeSpaLink>
          </ListWrapper>
        ))}
      </Links>
    </Body>
  )
}
